<agr-page-detail
  [pageTitle]="
    ('soilAnalysesReportTitle' | translate) +
    ' ' +
    (cropYear$ | async) +
    ', ' +
    (customer$ | async)?.name
  "
  [isEmpty]="(cropFieldsWithSoilAnalyses$ | async)?.length === 0"
  [emptyTitle]="'noSoilAnalyses' | translate"
  [emptyDescription]="'noSoilAnalysesFound' | translate"
  [hasPrimaryAction]="(cropFieldsWithSoilAnalyses$ | async)?.length > 0"
  primaryActionIcon="print"
  [primaryActionText]="'printSoilAnalysesReport' | translate"
  (primaryAction)="print()"
  (backAction)="back()"
  [buttonItems]="buttonItems$ | async"
  (buttonAction)="buttonAction($event)"
>
  <agr-print-page [marginLeft]="true" [showPageNumber]="false">
    <div class="page-break-before">
      <div class="spacing--margin-vertical">
        <app-general-info></app-general-info>
      </div>

      <div class="spacing--margin-vertical">
        <mat-accordion>
          @for (cropField of sortedCropFields$ | async; track cropField; let cropField_i = $index) {
            <mat-expansion-panel data-test="report-cropField">
              <mat-expansion-panel-header>
                <mat-panel-title class="flex__child flex__child-1">
                  <span class="print-only item-index">{{ cropField_i + 1 }} </span>&nbsp;{{
                    cropField.name
                  }}
                </mat-panel-title>
                <mat-panel-description class="flex__child flex__child-1 screen-only">
                  {{ cropField.cropName }} (
                  {{ cropField.soilAnalyses.length }}
                  {{
                    (cropField.soilAnalyses.length === 1 ? 'soilAnalysis' : 'soilAnalyses')
                      | translate
                      | lowercase
                  }})
                </mat-panel-description>
              </mat-expansion-panel-header>
              @for (soilAnalysis of cropField.soilAnalyses; track soilAnalysis) {
                <div class="spacing--margin-bottom">
                  <app-soil-analysis-detail
                    [soilAnalysis]="soilAnalysis"
                  ></app-soil-analysis-detail>
                </div>
              }
            </mat-expansion-panel>
          }
        </mat-accordion>
      </div>
    </div>
  </agr-print-page>
</agr-page-detail>
